import gql from 'graphql-tag';

export default gql`
	query DateNow {
		dateNow {
			now
		}
	}
`;
